import { Routes } from '@angular/router';
import { protectedOnlyGuard } from './core/auth/auth.guard';
import { publicOnlyGuard } from './core/auth/public-only.guard';
import { ErrorComponent } from './pages/error/error.component';
import { protectedRoutes } from './routes/protected.routes';
import { publicRoutes } from './routes/public.routes';
import { ProtectedLayoutComponent } from './shared/components/layout/protected-layout/protected-layout.component';
import { PublicLayoutComponent } from './shared/components/layout/public-layout/public-layout.component';

export const APP_ROUTES: Routes = [
	// Error page - accessible to everyone, at root level
	// Eagerly loaded to ensure it's always available, even if chunks fail
	{
		path: 'error',
		component: ErrorComponent,
	},

	// Public routes - for unauthenticated users (login, register, etc)
	// Authenticated users are redirected to dashboard
	{
		path: '',
		component: PublicLayoutComponent,
		canMatch: [publicOnlyGuard],
		children: publicRoutes,
	},

	// Protected routes - must be authenticated
	{
		path: '',
		component: ProtectedLayoutComponent,
		canMatch: [protectedOnlyGuard],
		children: protectedRoutes,
	},

	// Fallback
	{ path: '**', redirectTo: '/error' },
];